import { type FC } from 'react';

import styles from './FiltersOverlay.css';

type FiltersOverlayProps = {
  isDataLoading: boolean;
};

export const FiltersOverlay: FC<FiltersOverlayProps> = props => {
  const { isDataLoading } = props;

  if (!isDataLoading) {
    return null;
  }

  return <div className={styles['filters-overlay']}></div>;
};
